import React from 'react';
import { StoreMap, stores } from '../components/map/StoreMap';
import { KPICard } from '../components/ui/KPICard';
import { Star, MessageSquare, Store } from 'lucide-react';
export function HeatmapPage() {
  return <div className="flex flex-col h-[calc(100vh-64px)]" data-id="element-501">
      <div className="px-6 py-6 bg-lidl-light z-10" data-id="element-502">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-503">
          <KPICard title="Anzahl Filialen" value={stores.length.toString()} icon={<Store size={18} data-id="element-505" />} data-id="element-504" />
          <KPICard title="Ø Bewertungs-Score" value="4,2" icon={<Star size={18} data-id="element-507" />} data-id="element-506" />
          <KPICard title="Bewertungen gesamt" value="12.482" icon={<MessageSquare size={18} data-id="element-509" />} data-id="element-508" />
        </div>
      </div>
      <div className="flex-1 relative border-t border-gray-200" data-id="element-510">
        <StoreMap data-id="element-511" />
      </div>
    </div>;
}